var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('StackedBarChart',{attrs:{"xAxisData":_vm.xAxisData,"xAxisType":'category',"yAxisType":'value',"yAxisLabel":_vm.currencySymbol,"series":_vm.series,"formatter":_vm.formatter,"dataZoom":null,"legends":[],"dataViewFormatter":_vm.dataViewFormatter,"title":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }